var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"collapse"},[_vm._t("title"),_c('div',{ref:"content",staticClass:"collapse",class:{open: _vm.open}},[_c('div',{ref:"heightReference"},[_vm._t("default")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }